import {ValueObject} from '@s-ui/domain'

export class SpecsListValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array<SpecsValueObject>} params.items
   * */

  get value() {
    return {
      items: this._items.map(item => item.value)
    }
  }
}
